import { ACF } from './index'
/*****
 ********  ICI la class retourne les données a afficher dans le vue grâce au trie effectuée par la class incluse
 */

export class StepKeys {
  responseACF: Record<string, string>
  constructor (acfApi: Record<string, string>) {
    this.responseACF = acfApi
  }

  // Getter pour récuperer le json de l'api dans la class :
  get acfResponse (): Record<string, string> {
    return this.responseACF
  }

  // Prepare le JSON pour le rendre manipulable
  private sortResulACF (key: string): string {
    const acfsort = new ACF()
    if (this.acfResponse) {
      const value = acfsort.acfSort(key, this.acfResponse)
      return value
    }
    return ''
  }

  // Prepare l'objet pour le retourner sous forme d'informations lisible par vue
  private bakeArray (response: string, key: string): string {
    const acfsort = new ACF()
    if (this.acfResponse) {
      const value = acfsort.SetArrayForView(response, key)
      return value
    }
    return ''
  }

  // Récupaire l'objet transmit par l'API WP + affine la recherche pour obtenir 1 seul item
  public getValue (key: string): string {
    let bakingView = ''
    if (key.length > 0) {
      const response = this.sortResulACF(key)
      const updateKey = key + '_'
      bakingView = this.bakeArray(response, updateKey)
    }
    return bakingView
  }

  // Retourne la valeur enregistrée dans le ACF <!> seulement pour des valeurs simple qui ne dépendent pas d'un groupe <!>
  public getSimpleValue (key: string): string {
    if (key) {
      const response = this.sortResulACF(key)
      return response
    }
    return ''
  }
}
